"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = connectivityStatus;

var _connect = require("../actions/connect");

var _reconnect = require("../actions/reconnect");

var _disconnect = require("../../lib/actions/disconnect");

var _sagaError = require("../actions/sagaError");

var DEFAULT_STATE = 'uninitialized';

function connectivityStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      meta = _ref.meta;

  if (state !== 'sagaerror') {
    switch (type) {
      case _connect.CONNECT_PENDING:
      case _reconnect.RECONNECT_PENDING:
        if (state !== 'uninitialized') {
          state = 'reconnecting';
        }

        break;

      case _connect.CONNECT_FULFILLED:
        state = 'connected';
        break;

      case _reconnect.RECONNECT_FULFILLED:
        state = 'reconnected';
        break;

      case _connect.CONNECT_REJECTED:
        state = 'error';
        break;

      case _connect.CONNECT_STILL_PENDING:
        state = 'connectingslow';
        break;

      case _disconnect.DISCONNECT_FULFILLED:
        state = meta && meta.error ? 'error' : 'notconnected';
        break;

      case _sagaError.SAGA_ERROR:
        state = 'sagaerror';
        break;

      default:
        break;
    }
  }

  return state;
}